import client from "../client";

/** Admin-only endpoints (user management + dashboard stats). */
export const adminApi = {
  /** Aggregate counts for the admin dashboard. */
  async getStats() {
    const { data } = await client.get("/admin/stats");
    return data;
  },
  /** List every user in the system. */
  async listUsers() {
    const { data } = await client.get("/admin/users");
    return data;
  },
  /** Create a new user (admin-only). Returns the new UserOut including
   * the auto-assigned ``userIdCode`` (e.g. ``PHM0004``). */
  async createUser({ email, password, fullName, role }) {
    const { data } = await client.post("/admin/users", {
      email,
      password,
      fullName,
      role,
    });
    return data;
  },
  /** Toggle a user's is_active flag. */
  async toggleActive(id, isActive) {
    const { data } = await client.patch(`/admin/users/${id}/active`, { isActive });
    return data;
  },
};
